export const BLANK_CURRENT_PASSWORD = 'Please enter your current password';
export const BLANK_OR_INVALID_PASSWORD = 'Please enter a password that meets the requirements';
export const INVALID_CHARACTER = 'You have entered an invalid character';
export const GENERIC_PASSWORD_ERROR = 'Please enter a password that meets the requirements';
export const PASSWORDS_IDENTICAL_ERROR = 'Please enter a new password that is different to your current password';
export const PASSWORD_TOO_LONG =
    'The password you entered is too long. Please enter a password that is not more than 64 characters';

export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}$)/;
// Not sure why eslint complains, this regex matches any non-ascii character
// eslint-disable-next-line no-control-regex
export const nonAsciiRegex = /[^\x00-\x7F]/;

interface Validation {
    label: string;
    analyticsTag: string;
    validate: (pass: string) => boolean;
}

export const validations: Validation[] = [
    {
        label: 'Eight characters',
        analyticsTag: 'password-validation-not-at-least-eight-characters',
        validate: (pass): boolean => {
            return pass.length >= 8;
        },
    },
    {
        label: 'One uppercase letter',
        analyticsTag: 'password-validation-not-at-least-one-uppercase-character',

        validate: (pass): boolean => {
            return /(?=.*[A-Z])/.test(pass);
        },
    },
    {
        label: 'One lowercase letter',
        analyticsTag: 'password-validation-not-at-least-one-lowercase-character',

        validate: (pass): boolean => {
            return /(?=.*[a-z])/.test(pass);
        },
    },
    {
        label: 'One number',
        analyticsTag: 'password-validation-not-at-least-one-number',

        validate: (pass): boolean => {
            return /(?=.*[0-9])/.test(pass);
        },
    },
];
